<template>
  <div>
    <div v-if="$vuetify.breakpoint.smAndDown" class="text-center">
      <v-img
        :width="72"
        :height="72"
        class="col-auto mt-6 mx-auto"
        :src="$asset('img/icons/stop.svg')"
      />
      <div class="mt-4 mt-md-6 mb-4 text-h1">
        {{ title }}
      </div>
    </div>
    <template v-if="step > 1">
      <div
        class="mb-8 mb-md-6"
        :class="{
          'text-center': $vuetify.breakpoint.smAndDown
        }"
      >
        <span v-if="deleted" v-html="$t('profile.removeDialog.confirmText')" />
        <span v-else-if="step === 1">
          {{ $t('profile.removeDialog.areYouSure.text') }}
        </span>
      </div>
      <div v-if="step === 2">
        <div
          class="pa-4 pa-md-0 mb-8 mb-md-6"
          :class="{
            'grey rounded-lg': $vuetify.breakpoint.smAndDown
          }"
        >
          <div
            v-for="(item, index) in $t('profile.removeDialog.list', { returnObjects: true })"
            :key="index"
            class="d-flex align-center"
            :class="{
              'pb-4': index < $t('profile.removeDialog.list', { returnObjects: true }).length - 1
            }"
          >
            <div class="mr-4">
              <v-img width="48" height="48" contain :src="$asset(`img/icons/${item.icon}.svg`)" />
            </div>
            <div class="py-0 text-left">{{ item.text }}</div>
          </div>
        </div>
        <i18n path="profile.removeDialog.footer" tag="p" class="my-0 text-left">
          <template #email>
            <a :href="`mailto:${$t('ulekareContacts.email')}`" class="link--inline">{{
              $t('ulekareContacts.email')
            }}</a>
          </template>
          <template #phone>
            <span class="link--inline" v-html="createPhoneLink()" />
          </template>
        </i18n>
      </div>
      <div v-if="step === 3 && !deleted">
        <AccountDeleteFeedbackForm />
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import phoneLink from '@/mixins/phoneLink';

export default {
  name: 'AccountDelete',
  mixins: [phoneLink],
  computed: {
    ...mapGetters({
      deleted: 'profile/accountDelete/deleted',
      step: 'profile/accountDelete/step'
    }),
    title() {
      if (this.deleted) {
        return this.$t('profile.removeDialog.confirmTitle');
      }

      switch (this.step) {
        case 1:
          return this.$t('profile.removeDialog.areYouSure.title');
        case 3:
          return this.$t('profile.removeDialog.feedback.title');
        case 2:
        default:
          return this.$t('profile.removeDialog.title');
      }
    }
  }
};
</script>
